module.exports = require('./AccessibilityToolbar.vue');



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-accessibility-toolbar/src/index.js
// module id = 2L0W
// module chunks = 70